import { useState } from 'react';
import { aboutData, carouselData, mediaData } from '@/mocks/homeData';

export default function SectionsThree() {
  return (
    <>
      <section id="about" className="py-14 md:py-20 px-4 md:px-6 scroll-mt-20">
        <div className="max-w-7xl mx-auto">
          <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
            <div className="flex-1">
              <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-6">
                {aboutData.title}
              </h2>
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-4">
                {aboutData.desc1}
              </p>
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
                {aboutData.desc2}
              </p>
            </div>

            <div className="flex-1 w-full max-w-lg lg:max-w-none">
              <AboutImage />
            </div>
          </div>
        </div>
      </section>

      <section id="carousel" className="py-14 md:py-20 px-4 md:px-6 bg-background-100 scroll-mt-20">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
              焦点专题
            </h2>
            <p className="text-sm text-foreground-500 max-w-xl mx-auto">
              精选四大经典电影主题，深入探索8090年代最具代表性的银幕记忆
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {carouselData.map((item) => (
              <CarouselCard key={item.id} item={item} />
            ))}
          </div>
        </div>
      </section>

      <section id="media" className="py-14 md:py-20 px-4 md:px-6 scroll-mt-20">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
              经典片段
            </h2>
            <p className="text-sm text-foreground-500 max-w-xl mx-auto">
              重温那些刻在记忆里的经典电影片段，每一帧都是无法复刻的传奇
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
            {mediaData.map((item) => (
              <MediaCard key={item.id} item={item} />
            ))}
          </div>
        </div>
      </section>
    </>
  );
}

function AboutImage() {
  const [error, setError] = useState(false);
  if (error) return null;
  return (
    <div className="relative w-full aspect-[7/5] rounded-xl overflow-hidden">
      <img
        src={aboutData.image}
        alt="8090影院温暖怀旧观影空间"
        className="w-full h-full object-cover"
        onError={() => setError(true)}
        loading="lazy"
      />
    </div>
  );
}

function CarouselCard({ item }: { item: typeof carouselData[0] }) {
  const [error, setError] = useState(false);
  return (
    <article className="group bg-background-50 rounded-xl border border-background-200 overflow-hidden hover:border-accent-200 transition-all duration-300 cursor-pointer">
      {!error && (
        <div className="relative w-full aspect-[16/9] overflow-hidden">
          <img
            src={item.image}
            alt={item.title}
            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
            onError={() => setError(true)}
            loading="lazy"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent"></div>
        </div>
      )}
      <div className="p-5">
        <h3 className="font-heading text-lg font-semibold text-foreground-950 mb-2 group-hover:text-accent-600 transition-colors">
          {item.title}
        </h3>
        <p className="text-sm text-foreground-500 leading-relaxed">{item.desc}</p>
      </div>
    </article>
  );
}

function MediaCard({ item }: { item: typeof mediaData[0] }) {
  const [error, setError] = useState(false);
  return (
    <article className="group bg-background-50 rounded-xl border border-background-200 overflow-hidden hover:border-primary-200 transition-all duration-200 cursor-pointer">
      {!error ? (
        <div className="relative w-full aspect-video overflow-hidden">
          <img
            src={item.image}
            alt={item.title}
            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
            onError={() => setError(true)}
            loading="lazy"
          />
          <div className="absolute inset-0 bg-black/20 group-hover:bg-black/30 transition-colors flex items-center justify-center">
            <div className="w-12 h-12 flex items-center justify-center rounded-full bg-background-50/90 text-accent-500 group-hover:scale-110 transition-transform duration-300">
              <i className="ri-play-fill text-2xl"></i>
            </div>
          </div>
          <div className="absolute bottom-2 right-2 px-2 py-0.5 rounded bg-black/60 text-white text-xs font-medium">
            {item.duration}
          </div>
        </div>
      ) : (
        <div className="w-full aspect-video bg-background-200 flex items-center justify-center">
          <i className="ri-image-line text-3xl text-foreground-300"></i>
        </div>
      )}
      <div className="p-4">
        <h3 className="font-heading text-sm font-semibold text-foreground-950 mb-1.5 group-hover:text-primary-600 transition-colors line-clamp-1">
          {item.title}
        </h3>
        <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2">{item.desc}</p>
      </div>
    </article>
  );
}